import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { SIZES } from "theme";
import { COLORS } from "theme";

const TestimonialCards = ({
  small,
  name,
  description,
  designation,
  Image,
  alt,
}) => {
  return (
    <Box
      h={small ? "330px" : "250px"}
      w={small ? "280px" : "350px"}
      bgc={COLORS.lightBlack}
      margin="0 auto"
      padding="24px"
      display="flex"
      flexDirection="column"
      b="1px solid #99CEFB"
      justifyContent="center" // Center content vertically
      alignItems="center" // Center content horizontally
      boxShadow="0px 15px 40px #0000001F"
      position="relative"
      color="white"
      textAlign="start"
    >
      <Box
        display="flex"
        alignItems="center"
        marginBottom="16px"
        bgc={COLORS.lightBlack}
      >
        {
          Image ? <img
          src={Image}
          alt={alt}
          height={50}
          width={50}
          style={{ borderRadius: "50%", marginRight: "16px" }}
        /> : <span className="material-symbols-outlined" style={{fontSize:'50px', paddingRight:24}}>
        account_circle
        </span>
        }
        <Box display="flex" flexDirection="column">
          <Text fontSize="17px" fontWeight="bold" margin={0}>
            {name}
          </Text>
          <Text fontSize="13px" color="rgba(255, 255, 255, 0.7)" margin={0}>
            {designation}
          </Text>
          {/* <Box display="flex" marginTop="8px">

            {Array(5)
              .fill(null)
              .map((_, index) => (
                <span
                  key={index}
                  style={{
                    color: COLORS.primary,
                    fontSize: "18px",
                    marginRight: "4px",
                  }}
                >
                  ★
                </span>
              ))}
          </Box> */}
        </Box>
      </Box>
      <Text fontSize={SIZES.sizteen} lineHeight="1.5" opacity="0.9">
        {description}
      </Text>
    </Box>
  );
};

export default TestimonialCards;
